import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changePage, changePerPage, loadPopularData } from './actions';
import { selectPopular } from './selectors';
import { makeSelectPatterns } from '../HomePage/selectors';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import withI18next from '~/../hocs/_withI18next';
import Breadcrumb from '~/components/Breadcrumb';
import Gallery from '~/components/Gallery';
import GridGallery from '~/components/Gallery/GridGallery';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import NextPageButton from '~/components/NextPageButton';
// import Pagination from '~/components/Pagination';
import config, { keyConfig } from '~/config';
import { urls } from '~/utils';
import theme from '~/shared/themeVariables';
import { formatNumberWithCommas } from '~/utils/formatter';
import I18nRouter from '~/components/I18nRouter';
import GalleryIllust from '~/components/Gallery/GalleryIllust';
import themeVariables from '~/shared/themeVariables';
import PaginationNew from '~/components/PaginationNew';

@withI18next()
class PopularPage extends React.Component {
  onChangePerPage = (value, currentLang) => {
    this.props.changePerPage(value);
    const query = Object.assign({}, this.props.popularPage.query, {
      per_page: value,
    });
    this.props.loadPopularData(query);

    const { ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);

    I18nRouter.push(
      {
        pathname: '/popular-design',
        query,
        shallow: true,
      },
      `/${keyConfig.get('route_popular_page')}?${path}`,
    );
  };

  onNextLink() {
    let currentPage = this.props.popularPage.query.page;
    if (currentPage >= this.props.popularPage.totalPage) {
      return {};
    }
    currentPage++;

    const query = { ...this.props.popularPage.query, page: currentPage };

    const { ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);
    return {
      asPath: `/${this.props.currentLanguage}/${keyConfig.get(
        'route_popular_page',
      )}?${path}`,
      query: { ...this.props.popularPage.query, page: currentPage },
    };
  }

  isUsingGridGallery(dataType) {
    return (
      dataType === config.roles.POWERPOINT ||
      dataType === config.roles.WEB_TEMPLATE ||
      dataType === config.roles.ADSENSE
    );
  }

  renderGridLayout(dataType) {
    const imageSize = config.getFixedSizeByDataType(dataType);
    const { photos } = this.props.popularPage;
    if (this.isUsingGridGallery(dataType)) {
      return (
        <GridGallery
          images={photos}
          currentLang={this.props.currentLanguage}
          lastRowHide={false}
          colWidth={imageSize.width}
          rowHeight={imageSize.height}
          onClickImage={(item) =>
            this.onClickImage(item, this.props.currentLanguage)
          }
          showImageActions
          api={this.props.api}
        />
      );
    }
    if (config.isIllustAC()) {
      return (
        <GalleryIllust
          images={photos}
          currentLang={this.props.currentLanguage}
          lastRowHide={false}
          onClickImage={(item) =>
            this.onClickImage(item, this.props.currentLanguage)
          }
          prepareLoad={this.props.loading}
          showImageActions
          api={this.props.api}
          toggleFilterSearch={false} //fake = true to reduce count image in row
          isNotFullWidthCustom={false} // fake = true to reduce count image when not full 100vw
        />
      );
    }
    return (
      <Gallery
        images={photos}
        currentLang={this.props.currentLanguage}
        lastRowHide={false}
        colWidth={imageSize.width}
        rowHeight={imageSize.height}
        onClickImage={(item) =>
          this.onClickImage(item, this.props.currentLanguage)
        }
        prepareLoad={this.props.loading}
        showImageActions
        api={this.props.api}
      />
    );
  }

  renderNavigationAndBreadCrum(
    t,
    currentLanguage,
    page,
    perPage,
    totalPage,
    query,
    slug,
  ) {
    const pageText = t('page_text', { page });
    return (
      <div className="breadcrumb-wrapper">
        <div className="col-sm-8 breadcrumb-left">
          {+page === 1 ? (
            <Breadcrumb
              title={t(config.getPrefixContent('popular_resources'))}
            />
          ) : (
            <Breadcrumb
              title={`${t(
                config.getPrefixContent('popular_resources'),
              )} ${pageText}`}
            />
          )}
        </div>
        <div className="col-sm-4 pagination-right">
          {/* <Filter>
            <div className="filter-item" style={{ padding: '10px 15px' }}>
              <div className="filter-title">{t('filter_per_page')}</div>
              <div className="filter-content">
                <Radio
                  style={{ paddingRight: 15 }}
                  onChange={() => this.onChangePerPage('100', currentLanguage)}
                  checked={+perPage === 100}
                  groupName="perPage"
                  label="100"
                />
                <Radio
                  style={{ paddingRight: 15 }}
                  onChange={() => this.onChangePerPage('150', currentLanguage)}
                  checked={+perPage === 150}
                  groupName="perPage"
                  label="150"
                />
                <Radio
                  style={{ paddingRight: 15 }}
                  onChange={() => this.onChangePerPage('200', currentLanguage)}
                  checked={+perPage === 200}
                  groupName="perPage"
                  label="200"
                />
              </div>
            </div>
          </Filter> */}
          {/* <div className="ac-divider-vertical" /> */}
          <PaginationNew
            currentPage={+page}
            totalPage={+totalPage}
            onChange={this.onChangePage}
            query={query}
            path="/popular-design"
            asPath={`/${keyConfig.get('route_popular_page')}`}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      photos,
      totalPage,
      error,
      loading,
      dataType,
      query,
      totalItem,
      has_next,
    } = this.props.popularPage;
    const { t, currentLanguage } = this.props;
    const { page, per_page } = query;
    return (
      <div>
        {!error ? (
          <div className="search-result-page bg-gray">
            {!loading ? (
              <div>
                <h1 className="title-head text-center bg-gray-head text-white">
                  {t(config.getPrefixContent('heading_popular_page'))}
                </h1>
                <div className="container-fluid bg-white">
                  {this.renderNavigationAndBreadCrum(
                    t,
                    currentLanguage,
                    page,
                    per_page,
                    totalPage,
                    query,
                  )}
                </div>
                <div style={{ padding: 15, background: theme.color.gray }}>
                  <div className="container-fluid">
                    {!loading && photos.length === 0 && (
                      <div
                        style={{ padding: '15px 0' }}
                        className="text-center"
                      >
                        <h3
                          dangerouslySetInnerHTML={{
                            __html: t('photo_no_result_search_page'),
                          }}
                        />
                      </div>
                    )}
                    {!loading && photos.length >= 1 && (
                      <div>
                        {this.renderGridLayout(dataType)}
                        {has_next && (
                          <div className="popular-footer-container">
                            <div className="popular-footer-btn-next">
                              <NextPageButton
                                pathname="/popular-design"
                                query={this.onNextLink().query}
                                as={this.onNextLink().asPath}
                                t={t}
                                type="next_page"
                              />
                            </div>
                            {/* <div
                              className="popular-footer-pagination"
                              // style={{ float: 'right', marginTop: '-59px' }}
                            > */}
                            <PaginationNew
                              currentPage={+page}
                              totalPage={+totalPage}
                              onChange={this.onChangePage}
                              query={query}
                              path="/popular-design"
                              asPath={`/${keyConfig.get('route_popular_page')}`}
                            />
                            {/* </div> */}
                          </div>
                        )}
                        {config.serviceType !== 'design_ac' ? (
                          <div className="container" style={{ paddingTop: 30 }}>
                            <div
                              className={`col-md-8 text-center col-md-offset-2 ${
                                photos.length ? '' : 'md-ptb-150'
                              }`}
                            >
                              {photos.length ? (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: t(
                                      config.getPrefixContent('photo_list_des'),
                                      {
                                        number: formatNumberWithCommas(
                                          totalItem,
                                        ),
                                      },
                                    ),
                                  }}
                                />
                              ) : (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: t('change_param_message'),
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <LoadingSpinner />
            )}
          </div>
        ) : null}
        <style jsx>
          {`
            .title-head {
              background: #666;
              padding: 8px;
              font-size: 16px;
            }

            .popular-footer-container {
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            }
            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.minWidth}px) {
              .popular-footer-container {
                justify-content: center;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .search-result-page .breadcrumb-wrapper {
              display: flex;
              padding: 5px 0;
            }
            .search-result-page .breadcrumb-wrapper .breadcrumb-left,
            .search-result-page .breadcrumb-wrapper .pagination-right {
              flex-basis: 0;
              flex-grow: 1;
              max-width: 100%;
              display: flex;
              align-items: center;
            }
            .search-result-page .breadcrumb-wrapper .pagination-right {
              justify-content: flex-end;
              padding-right: 15px;
            }

            .search-result-page .filter-item {
              display: flex;
              min-width: 350px;
            }

            .search-result-page .filter-title {
              flex-basis: 0;
              flex-grow: 1;
            }

            .search-result-page .filter-content {
              flex-basis: 0;
              flex-grow: 2;
              display: flex;
            }

            .pagination-right-number {
              text-align: right;
            }

            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.minWidth}px) {
              .search-result-page .breadcrumb-wrapper {
                display: block;
              }

              .popular-footer-container .popular-footer-btn-next {
                display: none;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  popularPage: selectPopular,
  patterns: makeSelectPatterns(),
  currentLanguage: makeSelectCurrentLanguage(),
});
const mapDispatchToProps = (dispatch) => ({
  loadPopularData: (query) => dispatch(loadPopularData(query)),
  changePerPage: (value) => dispatch(changePerPage(value)),
  changePage: (value) => dispatch(changePage(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PopularPage);
